import React, {
  Dispatch,
  useContext,
  createContext,
  useState,
  SetStateAction,
} from "react";

export type ViewState = "info" | "form" | "formSuccess";

export interface IViewContext {
  formViewState: ViewState;
  setFormViewState: Dispatch<SetStateAction<ViewState>>;
}

const SalesforceViewContext = createContext({
  currentView: "info",
  setCurrentView: (formViewState: ViewState) => {},
});

export const useSalesforceViewContext = () => {
  return useContext(SalesforceViewContext);
};

export const SalesforceFormContext = ({ children }: any) => {
  const [formViewState, setFormViewState] = useState<ViewState>("info");

  return (
    <SalesforceViewContext.Provider
      value={{ currentView: formViewState, setCurrentView: setFormViewState }}
    >
      {children}
    </SalesforceViewContext.Provider>
  );
};

export default SalesforceFormContext;
